module.exports = __webpack_public_path__ + "media/application/images/svgs/rewind-f4ce74934f076e1cdcd43d0c2dbe263a.svg";